<template>
  <search-panel>
    <template v-slot:bar="props">
      <search-bar :q="props.q" />
      <q-checkbox v-model="googleSearch" label="Cercar per tot internet" />
    </template>
    <template v-slot:instructions>
      Si us plau, escriviu quelcom a cercar, per exemple: <br><br>

      <q-list>
        <q-item
          v-for="instruction of instructions" :key="instruction.label"
        >
          <q-item-section>
            <q-item-label>{{instruction.label}}:</q-item-label>
            <q-item-label caption><i>{{instruction.caption}}</i></q-item-label>
          </q-item-section>
        </q-item>
    </q-list>
    </template>
  </search-panel>
</template>

<script>
import { QCheckbox, QItem, QItemSection, QItemLabel, QList } from 'quasar'
import { SearchBar, SearchPanel } from '@giscube/geoportal'

export default {
  components: {
    QCheckbox,
    QItem,
    QItemSection,
    QItemLabel,
    QList,
    SearchBar,
    SearchPanel
  },
  data () {
    return {
      instructions: [
        { label: 'Cercar coordenades', caption: '41.155006, 1.110992' },
        { label: 'Cercar noms de carrers', caption: 'tetuan' },
        { label: 'Direccions', caption: 'prim 14' },
        { label: 'Serveis', caption: 'parquings' },
        { label: 'Referències cadastrals', caption: '3165102CF4536C' },
        { label: 'Barris', caption: 'xalets quintana' },
        { label: 'Llocs i topònims', caption: 'biblioteca pere anguera' }
      ]
    }
  },
  beforeRouteEnter: SearchPanel.beforeRouteEnter,
  beforeRouteUpdate: SearchPanel.beforeRouteUpdate,
  beforeRouteLeave: SearchPanel.beforeRouteLeave,
  computed: {
    beforeSearch () {
      return this.$store.getters['search/results'] == null
    },
    googleSearch: {
      get () {
        return this.$store.state.infraplan.googleSearch
      },
      set (v) {
        this.$store.state.infraplan.googleSearch = v
      }
    }
  }
}
</script>
